module.exports = __webpack_public_path__ + "img/alpitec.3e37dcc4.jpg";